/**
 * Decorative illustration of overlapping coloured circles. Used as the
 * eyebrow on GroupOfferBanner (small) and GroupStartSheet (large).
 */
export interface GroupIlloProps {
  size?: number;
}

export function GroupIllo({ size = 180 }: GroupIlloProps) {
  const h = Math.round(size * 0.66);
  const circleStyle: React.CSSProperties = {
    position: "absolute",
    borderRadius: 999,
    display: "grid",
    placeItems: "center",
    color: "#fff",
    fontWeight: 800,
    fontSize: 22,
    boxShadow: "0 6px 20px -6px rgba(0,0,0,0.25)",
  };
  return (
    <div
      style={{ position: "relative", width: size, height: h }}
      aria-hidden
    >
      <div
        style={{
          ...circleStyle,
          left: "8%",
          top: "10%",
          width: Math.round(size * 0.42),
          height: Math.round(size * 0.42),
          background: "linear-gradient(135deg,#fde2eb,#e0376b)",
        }}
      >
        M
      </div>
      <div
        style={{
          ...circleStyle,
          left: "32%",
          top: "30%",
          width: Math.round(size * 0.42),
          height: Math.round(size * 0.42),
          background: "linear-gradient(135deg,#dbe7fb,#1f6feb)",
        }}
      >
        A
      </div>
      <div
        style={{
          ...circleStyle,
          left: "56%",
          top: "10%",
          width: Math.round(size * 0.42),
          height: Math.round(size * 0.42),
          background: "linear-gradient(135deg,#fbe7c4,#d18a25)",
        }}
      >
        S
      </div>
      <div
        style={{
          ...circleStyle,
          left: "44%",
          top: "44%",
          width: Math.round(size * 0.36),
          height: Math.round(size * 0.36),
          background: "linear-gradient(135deg,#e8dfff,#7547d6)",
          fontSize: Math.round(size * 0.1),
        }}
      >
        +
      </div>
    </div>
  );
}
